// Backend tag: "Booked" | "Pre-inspection" | "Under-inspection" | "Completed".
// Job Detail passes it lowercased (adaptJobs), so compare case-insensitively.
export const hasJobSetup = (appointment) =>
  Boolean(appointment?.tag) && appointment.tag.toLowerCase() !== "booked";
